import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { ReactComponent as KaizIQText } from '@Assets/kaiziqText.svg';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';
import './Footer.scss';

export default function Footer() {

    const navigate = useNavigate();
    const { activeUser } = useReduxActiveUser();
    const className = 'footer';

    const isLoggedIn = !!activeUser && Object.keys(activeUser).length > 0 && activeUser?.id > 0;

    const handleTrackClick = () => {
        if (!isLoggedIn) {
            navigate('/login', { state: { from: { pathname: '/home/track' } } });
        } else {
            navigate('/home/track');
        }
    };

    const navCols = [
        {
            heading: 'Product',
            links: [
                { label: 'Report a Ticket',   onClick: () => navigate('/home/form/search') },
                { label: 'Track Your Ticket', onClick: handleTrackClick },
                { label: 'Pricing',           onClick: () => navigate('/pricing') },
                { label: 'Why KaizIQ',        onClick: () => navigate('/why-kaiziq') },
                { label: 'Changelog',         onClick: () => navigate('/changelog') },
            ],
        },
        {
            heading: 'Resources',
            links: [
                { label: 'Documentation',    onClick: () => window.open('https://docs.kaiziq.io', '_blank') },
                { label: 'Customer Support', onClick: () => navigate('/support') },
                { label: 'Case Studies',     onClick: () => navigate('/case-studies') },
                { label: 'Ebooks',           onClick: () => navigate('/ebooks') },
            ],
        },
        {
            heading: 'Company',
            links: [
                { label: 'Blog', onClick: () => navigate('/blogs') },
            ],
        },
    ];

    return (
        <footer className={className}>
            <div className={className + '__inner'}>

                {/* Brand */}
                <div className={className + '__brand'}>
                    <KaizIQText className={className + '__brand__logo'} />
                    <p className={className + '__brand__tagline'}>
                        Smart ticket management built for teams that move fast.
                    </p>
                    <div className={className + '__brand__contact'}>
                        <span className={className + '__brand__contact__item'}>
                            <Mail size={13} />
                            <span>support@kaiziq.com</span>
                        </span>
                    </div>
                </div>

                {/* Nav columns */}
                {navCols.map((col) => (
                    <div key={col.heading} className={className + '__col'}>
                        <h4 className={className + '__col__heading'}>{col.heading}</h4>
                        <ul className={className + '__col__list'}>
                            {col.links.length > 0 ? (
                                col.links.map((link) => (
                                    <li key={link.label}>
                                        <span
                                            className={className + '__col__link'}
                                            onClick={link.onClick}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))
                            ) : (
                                <li className={className + '__col__placeholder'}>Coming soon</li>
                            )}
                        </ul>
                    </div>
                ))}
            </div>

            {/* Bottom bar */}
            <div className={className + '__bottom'}>
                <span>© {new Date().getFullYear()} KaizIQ Technologies. All rights reserved.</span>
                <div className={className + '__bottom__links'}>
                    <span>Privacy Policy</span>
                    <span className={className + '__bottom__sep'}>·</span>
                    <span>Terms of Service</span>
                </div>
            </div>
        </footer>
    );
}
